<template>
    <!-- Participant -->
    <div>
        <!--Individual CStrip-->
        <div class="row no-gutters">
            <div
                class="col-md-12 channelStrip p-1"
                :class="{ channelStripRecord: isRecording }"
            >
                <!--Channel Strip inner elements-->

                <!--Name Row-->
                <div
                    class="row name no-gutters justify-content-between pl-1 pt-1"
                >
                    <div class="col-auto">
                        {{ displayName }}
                        <span>(Local)</span>
                    </div>
                </div>
                <!--/Name Row-->

                <div v-if="videoTrack" class="row no-gutter">
                    <div class="col-12 pl-3 pt-1">
                        <video
                            playinline
                            autoplay
                            :src-object.prop.camel="mediaStream"
                            muted
                            style="width: 384px; height: 216px"
                        />
                    </div>
                </div>

                <!--Mute/PPM/Mic-Cut Glyph Row-->
                <div class="row no-gutters">
                    <!--PPM-->
                    <div class="col-12 col-lg-7 p-1" style="height: 50px">
                        <AudioMeter
                            :audioContext="audioContext"
                            :mediaStream="mediaStream"
                        />
                    </div>

                    <!--mute-->
                    <div class="col-8 col-lg-3 muteBtnCol p-1">
                        <ToggleButton 
                            :value="isMicCut"
                            textOn="Un-cut Mic"
                            textOff="Cut My Mic"
                            @toggle="toggleLocalMicCut"
                        />
                    </div>

                    <!-- Mic Cut Glyph Column-->
                    <div class="col-3 col-lg-1 p-1 text-center micCutCol">
                        <img
                            v-if="isMicCut"
                            src="@/assets/images/micCut.svg"
                            style="height: 38px"
                            class="img-fluid micCutIcon"
                            alt="Mic Muted"
                        />
                    </div>

                    <div class="col-1 col-lg-1 p-1"></div>
                </div>

                <div class="row no-gutters">
                    <div class="col-6">
                        <SelectMediaDevice
                            :disabled="isRecording"
                            :deviceId="audioDeviceId"
                            :devices="audioInputDevices"
                            @change="changeAudioInputDevice"
                        />
                    </div>

                    <div class="col-6">
                        <SelectMediaDevice
                            v-if="$store.state.allowVideo"
                            :disabled="isRecording"
                            :deviceId="videoDeviceId"
                            :devices="videoInputDevices"
                            @change="changeVideoInputDevice"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Participant -->
</template>

<style scoped>
    .channelStrip {
        background-color: #ebebeb;
        border-radius: 10px;
        border-width: 5px;
        border-color: black;
        border-style: solid;
    }

    .channelStripRecord {
        border-color: red;
    }

    .name {
        color: black;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>

<script>
import AudioMeter from "./PeakDisplay";
import SelectMediaDevice from "./SelectMediaDevice";
import ToggleButton from "./ToggleButton";

import { getAudioTrack, getVideoTrack, createMediaStream, filterDevices } from "../modules/MediaHelpers";

export default {
    name: "ParticipantLocal",
    props: {
        data: { type: Object },
        micCut: {type: Boolean}
    },

    data: () => {
        return {
            devices: [],
            audioDeviceId: localStorage.getItem("audioDeviceId"),
            videoDeviceId: localStorage.getItem("videoDeviceId"),
            audioTrack: null,
            videoTrack: null,
            isMicCut: false,
        };
    },

    watch: {
        micCut: function (newVal, oldVal) {
            if (newVal != oldVal) this.toggleLocalMicCut();
        }
    },

    computed: {
        mediaStream() {
            return createMediaStream([this.audioTrack, this.videoTrack]);
        },

        audioContext() {
            return this.$store.getters["audioContext"];
        },

        displayName() {
            return this.data.userData.displayName;
        },

        isRecording() {
            return this.$store.getters['isRecording'];
        },

        audioInputDevices() {
            return filterDevices(this.devices, 'audioinput');
        },

        videoInputDevices() {
            return filterDevices(this.devices, 'videoinput');
        }
    },

    methods: {
        async changeAudioInputDevice(deviceId) {
            this.audioTrack = await getAudioTrack({ deviceId: deviceId })
            this.audioDeviceId = this.audioTrack.getSettings().deviceId;
            if (deviceId === 'default') this.audioDeviceId = 'default';
            localStorage.setItem("audioDeviceId", this.audioDeviceId);
            this.$emit("audioTrack", this.audioTrack);
        },

        async changeVideoInputDevice(deviceId) {
            this.videoTrack = await getVideoTrack({ deviceId: deviceId })
            this.videoDeviceId = this.videoTrack.getSettings().deviceId;
            localStorage.setItem("videoDeviceId", this.videoDeviceId);
            this.$emit("videoTrack", this.videoTrack);
        },

        toggleLocalMicCut() {
            this.audioTrack.enabled = !this.audioTrack.enabled;
            this.isMicCut = !this.audioTrack.enabled;
            this.$emit("micCut", !this.audioTrack.enabled);
        },

        async updateDevices() {
            this.devices = await window.navigator.mediaDevices.enumerateDevices();
        },
    },

    created() {
        this.changeAudioInputDevice(this.audioDeviceId);

        window.navigator.mediaDevices.ondevicechange = this.updateDevices.bind(this);
        this.updateDevices();
    },

    components: {
        AudioMeter,
        SelectMediaDevice,
        ToggleButton
    },
};
</script>